import React from "react";
import {
  Button,
  Card,
  InputNumber,
  Space,
  Typography,
} from "antd";
import {
  DeleteOutlined,
  MinusOutlined,
  PlusOutlined,
} from "@ant-design/icons";

const { Text } = Typography;

const formatCurrency = (value) =>
  Number(value || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const CartItem = ({
  item,
  onIncrease,
  onDecrease,
  onQuantityChange,
  onCostChange,
  onRemove,
  isMobile,
}) => {
  const total =
    Number(item.quantity || 0) *
    Number(item.unitCost || 0);

  return (
    <Card
      size="small"
      style={{
        borderRadius: 12,
        marginBottom: 10,
      }}
      styles={{
        body: {
          padding: isMobile ? 14 : 12,
        },
      }}
    >
      <div
        style={{
          display: "flex",
          gap: 12,
          alignItems: isMobile
            ? "flex-start"
            : "center",
          flexDirection: isMobile
            ? "column"
            : "row",
        }}
      >
        {/* PRODUCT */}
        <div
          style={{
            flex: 1,
            minWidth: 0,
          }}
        >
          <Text strong>
            {item.partName}
          </Text>

          <div
            style={{
              marginTop: 3,
            }}
          >
            <Text
              type="secondary"
              style={{
                fontSize: 12,
              }}
            >
              {item.partNumber}
              {item.importerId
                ? ` • ${item.importerId}`
                : ""}
            </Text>
          </div>
        </div>

        {/* QUANTITY */}
        <div
          style={{
            width: isMobile ? "100%" : 160,
          }}
        >
          <Text
            type="secondary"
            style={{
              display: "block",
              fontSize: 11,
              marginBottom: 4,
            }}
          >
            Quantity
          </Text>

          <Space.Compact
            style={{
              width: "100%",
            }}
          >
            <Button
              icon={<MinusOutlined />}
              onClick={() =>
                onDecrease(item.sparepartId)
              }
            />

            <InputNumber
              min={1}
              value={item.quantity}
              onChange={(value) =>
                onQuantityChange(
                  item.sparepartId,
                  value
                )
              }
              controls={false}
              style={{
                width: "100%",
              }}
            />

            <Button
              icon={<PlusOutlined />}
              onClick={() =>
                onIncrease(item.sparepartId)
              }
            />
          </Space.Compact>
        </div>

        {/* UNIT COST */}
        <div
          style={{
            width: isMobile ? "100%" : 150,
          }}
        >
          <Text
            type="secondary"
            style={{
              display: "block",
              fontSize: 11,
              marginBottom: 4,
            }}
          >
            Unit Cost
          </Text>

          <InputNumber
            min={0}
            precision={2}
            value={item.unitCost}
            onChange={(value) =>
              onCostChange(
                item.sparepartId,
                value
              )
            }
            style={{
              width: "100%",
            }}
          />
        </div>

        {/* TOTAL */}
        <div
          style={{
            width: isMobile ? "100%" : 130,
            textAlign: isMobile
              ? "left"
              : "right",
          }}
        >
          <Text
            type="secondary"
            style={{
              display: "block",
              fontSize: 11,
            }}
          >
            Line Total
          </Text>

          <Text
            strong
            style={{
              fontSize: 16,
              color: "#1677ff",
            }}
          >
            {formatCurrency(total)}
          </Text>
        </div>

        {/* REMOVE */}
        <Button
          danger
          type="text"
          icon={<DeleteOutlined />}
          onClick={() =>
            onRemove(item.sparepartId)
          }
        />
      </div>
    </Card>
  );
};

export default CartItem;